var _mask, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2071_27099",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 13V18.3333C17 19.0406 16.801 19.7189 16.4468 20.219C16.0925 20.719 15.6121 21 15.1111 21H1.88889C1.38792 21 0.907478 20.719 0.553243 20.219C0.199007 19.7189 0 19.0406 0 18.3333V13"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13C19 11.8954 18.1046 11 17 11C15.8954 11 15 11.8954 15 13H19ZM0 18.3333H-2H0ZM2 13C2 11.8954 1.10457 11 0 11C-1.10457 11 -2 11.8954 -2 13H2ZM15 13V18.3333H19V13H15ZM15 18.3333C15 18.6924 14.8941 18.9509 14.8147 19.0629L18.0788 21.375C18.7079 20.4868 19 19.3888 19 18.3333H15ZM14.8147 19.0629C14.7803 19.1114 14.7751 19.0993 14.8244 19.0705C14.8782 19.0391 14.9784 19 15.1111 19V23C16.4087 23 17.4441 22.271 18.0788 21.375L14.8147 19.0629ZM15.1111 19H1.88889V23H15.1111V19ZM1.88889 19C2.02162 19 2.1218 19.0391 2.17564 19.0705C2.2249 19.0993 2.21966 19.1114 2.18529 19.0629L-1.07881 21.375C-0.44415 22.271 0.591314 23 1.88889 23V19ZM2.18529 19.0629C2.10593 18.9509 2 18.6924 2 18.3333H-2C-2 19.3888 -1.70792 20.4868 -1.07881 21.375L2.18529 19.0629ZM2 18.3333V13H-2V18.3333H2Z",
    fill: "#949494",
    mask: "url(#path-1-inside-1_2071_27099)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55554 1V13",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2778 6L8.55557 1L3.83334 6",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c062eed40894b414306929e8e7923992.svg";
export { ForwardRef as ReactComponent };